module.exports = __webpack_public_path__ + "img/loading.f6ef2f6b.gif";